import type { ReactNode } from 'react';

import { RetailerFooter } from '@/components/RetailerWidget/components/RetailerFooter/RetailerFooter';
import { RetailerHeader } from '@/components/RetailerWidget/components/RetailerHeader/RetailerHeader';
import type { StickyLayoutProps } from '@/components/StickyLayout';
import { StickyLayout } from '@/components/StickyLayout';
import type {
  ContentfulMainHeaderFragment,
  ContentfulSimpleFooterFragment,
} from '@/graphql/contentful/api';
import { theme } from '@/theme/getTheme';

import * as S from './RetailerLayout.styles';

export type CMSLayoutDataProps = {
  footer?: ContentfulSimpleFooterFragment | null;
  header?: ContentfulMainHeaderFragment | null;
};
export interface RetailerProps
  extends Pick<StickyLayoutProps, 'backgroundColor'> {
  children: ReactNode;
  cmsData?: CMSLayoutDataProps;
}

export const RetailerLayout = ({
  backgroundColor,
  children,
  cmsData,
}: RetailerProps) => {
  return (
    <StickyLayout
      backgroundColor={backgroundColor}
      style={{ minHeight: 'fit-content' }}
    >
      {cmsData?.header && (
        <RetailerHeader
          bannerImage={
            cmsData?.header?.backgroundImage?.url ??
            '/images/retailer-widget/banner.png'
          }
          logoImage={
            cmsData?.header?.logo?.url ?? '/assets/breitling-white.svg'
          }
        />
      )}
      <S.RetailerMain
        data-test-id='RetailerStickyLayoutMain'
        headerBackground={
          cmsData?.header?.background ??
          theme.components.header.defaultBackground
        }
      >
        {children}
      </S.RetailerMain>
      {cmsData?.footer && (
        <RetailerFooter
          bannerImage={
            cmsData?.footer?.background?.url ??
            '/images/retailer-widget/banner-footer.png'
          }
          cta={cmsData?.footer?.cta ?? 'DISCOVER OUR SELECTION'}
          description={
            cmsData?.footer?.description ??
            'Breitling - Purpose, action and style'
          }
          title={
            cmsData?.footer?.title ??
            'Breitling is renowned for its commitment to quality, passion, and performance. As one of the few independent watchmakers producing its own movements, Breitling ensures all calibers are COSC-certified, guaranteeing high accuracy. '
          }
        />
      )}
    </StickyLayout>
  );
};

RetailerLayout.displayName = 'Retailer';
